import { Inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";

import { environment } from "src/environments/environment";
import { UserSettingsService } from "./user-setting.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    @Inject(Router) private router: Router,
    public userServices: UserSettingsService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if(!this.userServices.validateToken()){
      this.userServices.logOut();
    }
  }

}
// Desloagueado
@Injectable({
  providedIn: "root",
})
export class OutGuard {
  constructor(
    @Inject(Router) private router: Router,
    public userServices: UserSettingsService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   
}
}
// Lead Guard
@Injectable({
  providedIn: "root",
})
export class LeadGuard {
  constructor(
    @Inject(Router) private router: Router,
    public userServices: UserSettingsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   
  }
}
